import { introJs } from 'intro.js'
import { trans } from 'utils/helpers/translation'

const beforeStep1 = () => {
    window.jQuery('[data-step="1"]').parents('.dropdown').addClass('open_tour')
}

const beforeStep2 = (isAdmin) => {
    if (!isAdmin)
        window.jQuery('[data-step="2"]').parents('.dropdown').addClass('open_tour')
}

const beforeStep3 = (isAdmin) => {
    let str = (isAdmin) ? '[data-step="1"]' : '[data-step="2"]'
    window.jQuery(str).parents('.dropdown').removeClass('open_tour')
    window.jQuery('[data-step="4"]').removeClass('open_floating')
    window.jQuery(str).parents('.dropdown').addClass('open_tour')
}

const beforeStep4 = (isAdmin) => {
    let str = (isAdmin) ? '[data-step="1"]' : '[data-step="2"]'
    window.jQuery('[data-step="4"]').addClass('open_floating')
    window.jQuery(str).parents('.dropdown').removeClass('open_tour')
}

const beforeStep5 = () => {
    window.jQuery('[data-step="4"]').removeClass('open_floating')
}

const beforeStep6 = () => {
}

const beforeStep7 = () => {
}

export default {
    start (isAdmin) {
        let tourFlow = [
            {
                element: window.document.querySelectorAll('[data-step="1"]')[0],
                intro: trans('_tour.step_01'),
                position: 'left'
            },
            {
                element: window.document.querySelectorAll('[data-step="2"]')[0],
                intro: trans('_tour.step_02'),
                position: 'left'
            },
            {
                element: window.document.querySelectorAll('[data-step="3"]')[0],
                intro: trans('_tour.step_03'),
                position: 'left'
            },
            {
                element: window.document.querySelectorAll('[data-step="4"]')[0],
                intro: trans('_tour.step_04'),
                position: 'top'
            },
            {
                element: window.document.querySelectorAll('[data-step="5"]')[0],
                intro: trans('_tour.step_05'),
                position: 'right'
            },
            {
                element: window.document.querySelectorAll('[data-step="6"]')[0],
                intro: trans('_tour.step_06'),
                position: 'right'
            },
            {
                element: window.document.querySelectorAll('[data-step="7"]')[0],
                intro: trans('_tour.step_07'),
                position: 'bottom'
            }
        ]
        introJs()
        .setOptions({
            'nextLabel': '<i class="fa fa-arrow-circle-right"></i>',
            'prevLabel': '<i class="fa fa-arrow-circle-left"></i>',
            'skipLabel': trans('_tour.tour_end'),
            'doneLabel': trans('_tour.tour_finish'),
            'hidePrev': true,
            'hideNext': true,
            'exitOnEsc': false,
            'exitOnOverlayClick': false,
            'showStepNumbers': false,
            'showBullets': true,
            'showProgress': false,
            'scrollToElement': false,
            'tooltipClass': 'meu-tooltipClass',
            'highlightClass': 'tour_progress'
        })
        .addSteps((isAdmin) ? tourFlow : tourFlow.slice(1, 7))
        .onchange((target) => {
            switch (parseInt(target.dataset.step)) {
            case 1: beforeStep1()
                break
            case 2: beforeStep2(isAdmin)
                break
            case 3: beforeStep3(isAdmin)
                break
            case 4: beforeStep4(isAdmin)
                break
            case 5: beforeStep5()
                break
            case 6: beforeStep6()
                break
            case 7: beforeStep7()
                break
            }
        })
        .onexit(() => {
            let str = (isAdmin) ? '[data-step="1"]' : '[data-step="2"]'
            window.localStorage.removeItem('pml_tour')
            window.jQuery(str).parents('.dropdown').removeClass('open_tour')
            window.jQuery('[data-step="4"]').removeClass('open_floating')
        })
        .start()
    }
}



// WEBPACK FOOTER //
// ./src/utils/helpers/tour.js